import R from 'app/assets/R'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { SectionBase } from 'app/components/common/SectionBase'
import { useTable } from './hook'
import { FilterLayout } from './layouts'
import { BaseTableReport, HeadPageWrapper, RootWrapper } from './styles'
import {
  FunctionPermissionEnum,
  ModulePermissionEnum,
} from 'app/common/permission-module'
import { useVerifyPermission } from 'app/common/use-verify-permission'

export const Report018Container = () => {
  const {
    filter,
    handleChangeFilter,
    data,
    columns,
    isLoading,
    handleTableChange,
    pagination,
    handleExportExcel,
  } = useTable()
  const { isHavePermissionFunction } = useVerifyPermission()

  return (
    <RootWrapper>
      <HeadPageWrapper
        titleI18nKey={R.strings.report_18}
        isExport={isHavePermissionFunction(
          ModulePermissionEnum.REPORT,
          FunctionPermissionEnum.REPORT_EXPORT_REPORT_18,
        )}
        onPressExport={handleExportExcel}
      />
      <SectionBase>
        <BaseSpace>
          <FilterLayout formData={filter} onChange={handleChangeFilter} />

          <BaseTableReport
            columns={columns}
            dataSource={data}
            pagination={pagination}
            loading={isLoading}
            onChange={handleTableChange}
            rowClassName="row-overwrite-style"
            scroll={{
              x: true,
            }}
          />
        </BaseSpace>
      </SectionBase>
    </RootWrapper>
  )
}
